<template>
  <dropdown
    ref="dropdown"
    v-model="show"
    class="export-csv-dropdown"
    menu-right
    :not-close-elements="dropdownElements"
  >
    <span class="export-csv-btn dropdown-toggle">
      <i class="fa fa-download m-r-5" />
      {{ $t('EXPORT_CSV') }}

      <i class="caret m-l-10" />
    </span>

    <template
      slot="dropdown"
    >
      <li
        v-show="!scheduleActive"
        class="p-t-5 p-b-5"
      >
        <a
          v-t="'FULL_EXPORT'"
          role="button"
          @click="exportFull"
        />
      </li>

      <li
        v-show="!scheduleActive"
        class="p-t-5 p-b-5"
      >
        <a
          v-t="'SELECTED_COLS'"
          role="button"
          @click="exportSelectCols"
        />
      </li>
      <!-- <li
        v-show="!scheduleActive"
        role="separator"
        class="divider"
      />
      <li
        v-show="!scheduleActive"
        class="m-b-10"
      >
        <a
          v-t="'SCHEDULE'"
          role="button"
          @click="selectDelivery"
        />
      </li> -->
      <div
        v-show="scheduleActive"
        class="schedule-delivery"
      >
        <p v-t="'SCHEDULE_TIP'" />
        <btn-group>
          <btn
            v-model="selectedDelivery"
            input-type="radio"
            input-value="hourly"
            type="primary"
          >
            {{ $t('HOURLY') }}
          </btn>
          <btn
            v-model="selectedDelivery"
            input-type="radio"
            input-value="daily"
            type="primary"
          >
            {{ $t('DAILY') }}
          </btn>
          <btn
            v-model="selectedDelivery"
            input-type="radio"
            input-value="weekly"
            type="primary"
          >
            {{ $t('WEEKLY') }}
          </btn>
          <btn
            v-model="selectedDelivery"
            input-type="radio"
            input-value="monthly"
            type="primary"
          >
            {{ $t('MONTHLY') }}
          </btn>
        </btn-group>
        <!-- <p
          v-if="selectedDelivery"
          v-t="selectedTip"
        /> -->
        <div class="pull-right">
          <btn
            v-t="'SCHEDULE'"
            type="success"
            :disabled="selectedDelivery === null"
            @click="scheduleReportDelivery"
          />
          <btn
            v-t="'CANCEL'"
            type="link"
            @click="cancel"
          />
        </div>
      </div>
    </template>
  </dropdown>
</template>

<script>
import sharedMessages from '@/core/locales';
import messages from '../locales';

export default {
  name: 'ExportCsv',
  props: {
    savedReport: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      show: false,
      scheduleActive: false,
      selectedDelivery: 'weekly',
      hourlyEveryNthMin: 0,
      dailyEveryNthHour: 0,
      weeklyEveryNthDay: 0,
      monthlyEveryNthDay: 0,
      dropdownElements: []
    };
  },
  computed: {
    selectedTip() {
      if (this.selectedDelivery) {
        return this.selectedDelivery.toUpperCase() + '_TIP';
      }
      return '';
    }
  },
  mounted () {
    this.dropdownElements.push(this.$refs.dropdown.$el);
  },
  methods: {
    resetData() {
      this.show = false;
      this.scheduleActive = false;
      this.selectedDelivery = 'weekly';
      this.hourlyEveryNthMin = 0;
      this.dailyEveryNthHour = 0;
      this.weeklyEveryNthDay = 0;
      this.monthlyEveryNthDay = 0;
    },
    selectDelivery() {
      this.show = true;
      this.scheduleActive = true;
    },
    scheduleReportDelivery() {
      this.$emit('scheduleReportDelivery', this.selectedDelivery);
      this.resetData();
    },
    cancel() {
      this.resetData();
    },
    exportFull() {
      this.$emit('exportFull');
      this.show = false;
    },
    exportSelectCols() {
      this.$emit('exportSelectCols');
      this.show = false;
    }
  },
  i18n: {
    locale: 'en',
    messages,
    sharedMessages
  }
};
</script>

<style lang="scss" scoped>
.export-csv-btn {
  border-left: 1px solid $reporting-settings-v2-grid-header-buttons-border-color;
  cursor: pointer;
  padding: 8px 10px;
  display: inline-flex;
  align-items: center;

  &:hover {
    color: var(--contrast);
  }
}

.export-csv-dropdown {
  height: 100%;
  display: flex;
  align-items: center;
}

.schedule-delivery {
  min-width: 290px;
  padding: 15px;
  p, .pull-right {
    margin-bottom: 15px;
  }
  .btn-group {
    margin-bottom: 20px;
  }
}
</style>